(function () {
  'use strict';

  if (window.__PS_FULLSCREEN_BACKGROUND_SCROLL_LOCK__) return;
  window.__PS_FULLSCREEN_BACKGROUND_SCROLL_LOCK__ = true;

  var BODY_OPEN_CLASS = 'product-gallery-fullscreen';
  var LOCK_DATA_KEY = 'psFullscreenScrollLocked';

  var savedScrollX = 0;
  var savedScrollY = 0;
  var savedBodyStyle = null;
  var savedHtmlStyle = null;
  var locked = false;

  function isFullscreenOpen() {
    return document.body &&
      document.body.classList.contains(BODY_OPEN_CLASS);
  }

  function lockBackgroundScroll() {
    if (locked || !document.body || !document.documentElement) return;

    var body = document.body;
    var html = document.documentElement;

    savedScrollX = window.pageXOffset || html.scrollLeft || 0;
    savedScrollY = window.pageYOffset || html.scrollTop || 0;

    /*
      Preserve the exact inline state so nothing else on the site is changed.
      Only background page scrolling is locked while fullscreen gallery is open.
    */
    savedBodyStyle = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      overscrollBehavior: body.style.overscrollBehavior
    };

    savedHtmlStyle = {
      overflow: html.style.overflow,
      overscrollBehavior: html.style.overscrollBehavior
    };

    html.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';

    body.style.position = 'fixed';
    body.style.top = '-' + savedScrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    body.style.overscrollBehavior = 'none';

    body.dataset[LOCK_DATA_KEY] = '1';
    locked = true;
  }

  function unlockBackgroundScroll() {
    if (!locked || !document.body || !document.documentElement) return;

    var body = document.body;
    var html = document.documentElement;

    if (savedBodyStyle) {
      body.style.position = savedBodyStyle.position;
      body.style.top = savedBodyStyle.top;
      body.style.left = savedBodyStyle.left;
      body.style.right = savedBodyStyle.right;
      body.style.width = savedBodyStyle.width;
      body.style.overflow = savedBodyStyle.overflow;
      body.style.overscrollBehavior = savedBodyStyle.overscrollBehavior;
    }

    if (savedHtmlStyle) {
      html.style.overflow = savedHtmlStyle.overflow;
      html.style.overscrollBehavior = savedHtmlStyle.overscrollBehavior;
    }

    delete body.dataset[LOCK_DATA_KEY];
    locked = false;

    /*
      Restore the exact PDP scroll position after fullscreen closes.
      No gallery, swipe, zoom, arrows, dots or cart logic is touched.
    */
    window.requestAnimationFrame(function () {
      window.scrollTo(savedScrollX, savedScrollY);
    });
  }

  function syncLockState() {
    if (isFullscreenOpen()) {
      lockBackgroundScroll();
    } else {
      unlockBackgroundScroll();
    }
  }

  function init() {
    if (!document.body) return;

    syncLockState();

    var observer = new MutationObserver(function () {
      syncLockState();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    window.addEventListener('pagehide', function () {
      if (locked) {
        unlockBackgroundScroll();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();